var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-datetimepicker',{attrs:{"value":_vm.localeToZonedTime(_vm.value),"placeholder":_vm.placeholder,"icon":_vm.icon,"min-datetime":_vm.localeToZonedTime(_vm.minDatetime),"max-datetime":_vm.localeToZonedTime(_vm.maxDatetime),"editable":"","locale":"fr-FR"},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }